(function () {
  'use strict';

  var ORDER_TRACKING_RETURN_ORIGINS = [
    'https://lab.lostgear.xyz',
    'http://localhost:3000',
    'http://127.0.0.1:3000'
  ];

  function builderString(key, fallback) {
    var strings = window.lostgearStrings && window.lostgearStrings.builder;
    return strings && strings[key] ? strings[key] : fallback;
  }

  function getOrderTrackingReturnTo() {
    try {
      var params = new URLSearchParams(window.location.search);
      var rawReturnTo = params.get('return_to');
      if (!rawReturnTo) return null;

      var returnToUrl = new URL(rawReturnTo, window.location.origin);
      var isAllowedOrigin =
        returnToUrl.origin === window.location.origin ||
        ORDER_TRACKING_RETURN_ORIGINS.indexOf(returnToUrl.origin) !== -1;
      var isOrderTrackingPath = /^\/(?:[a-z]{2}\/)?order-status\/[A-Za-z0-9]+$/.test(returnToUrl.pathname);

      if (!isAllowedOrigin || !isOrderTrackingPath) return null;
      return returnToUrl.toString();
    } catch (error) {
      console.warn('[lg-patch-builder] failed to parse return_to:', error);
      return null;
    }
  }

  function buildIframeUrl(root) {
    var apiBase = root.getAttribute('data-api-base') || window.lgApiBase || 'https://lab.lostgear.xyz';
    var locale = root.getAttribute('data-locale') || 'en';
    var productHandle = root.getAttribute('data-product-handle') || '';
    var configId = root.getAttribute('data-config-id') || '';
    var mode = root.getAttribute('data-builder-mode') || 'patch';
    var url = apiBase.replace(/\/$/, '') + '/' + locale + '/patch-builder?embedded=1&productHandle=' + encodeURIComponent(productHandle);
    if (configId) url += '&configId=' + encodeURIComponent(configId);
    if (mode === 'collar') url += '&mode=collar';
    if (root.getAttribute('data-animated-background') === 'patches') url += '&background=patches';
    return url;
  }

  function setError(root, message) {
    var wrapper = root.querySelector('[data-lg-patch-builder-error]');
    var text = root.querySelector('[data-lg-patch-builder-error-message]');
    if (!wrapper || !text) return;
    if (!message) {
      wrapper.setAttribute('hidden', 'hidden');
      text.textContent = '';
      return;
    }
    wrapper.removeAttribute('hidden');
    text.textContent = message;
  }

  function getCartSurface() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  async function getExpressState(root, handles) {
    var productHandles = [root.getAttribute('data-product-handle')].concat(handles || []).filter(Boolean);
    productHandles = productHandles.filter(function (handle, index) { return productHandles.indexOf(handle) === index; });
    var states = await Promise.all(productHandles.map(async function (handle) {
      var base = (window.Shopify && window.Shopify.routes.root) || '/';
      var response = await fetch(base + 'products/' + encodeURIComponent(handle) + '?section_id=lg-patch-express-state');
      if (!response.ok) throw new Error(builderString('expressCheckError', 'Could not check Express Production. Please try again.'));
      var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      var element = doc.querySelector('[data-lg-patch-express-state]');
      if (!element) throw new Error(builderString('expressCheckError', 'Could not check Express Production. Please try again.'));
      return JSON.parse(element.textContent);
    }));
    return Object.assign({}, states[0], {
      blocked: states.some(function (state) { return state.blocked; }),
      eligible: states.some(function (state) { return state.eligible; })
    });
  }

  function getSectionsToRender() {
    var ids = [];
    var cartDrawer = document.querySelector('cart-drawer');
    var cartNotification = document.querySelector('cart-notification');

    [cartDrawer, cartNotification].forEach(function (el) {
      if (!el || typeof el.getSectionsToRender !== 'function') return;
      el.getSectionsToRender().forEach(function (section) {
        if (ids.indexOf(section.id) === -1) ids.push(section.id);
      });
    });

    return ids;
  }

  function renderCart(data) {
    var cartDrawer = document.querySelector('cart-drawer');
    var cartNotification = document.querySelector('cart-notification');

    if (cartNotification) {
      if (cartNotification.classList.contains('is-empty')) cartNotification.classList.remove('is-empty');
      try { cartNotification.renderContents(data); } catch (error) { console.warn('[lg-patch-builder] notification render failed:', error); }
    }

    if (cartDrawer) {
      if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
      try { cartDrawer.renderContents(data); } catch (error) { console.warn('[lg-patch-builder] drawer render failed:', error); }
    }
  }

  async function addToCart(root, iframe, payload) {
    setError(root, '');

    if (!payload || !payload.cart || !payload.cart.id) {
      setError(root, builderString('invalidPayload', 'The builder did not return a valid cart payload.'));
      iframe.contentWindow.postMessage({ type: 'lg:patch-builder:add-to-cart-result', success: false, error: builderString('missingPayload', 'Missing cart payload.') }, '*');
      return;
    }

    var cart = getCartSurface();
    var sections = getSectionsToRender();
    if (cart && typeof cart.setActiveElement === 'function') {
      cart.setActiveElement(document.activeElement);
    }

    try {
      if (payload.expressProduction) {
        var expressState = await getExpressState(root, payload.productHandles);
        iframe.contentWindow.postMessage({ type: 'lg:patch-builder:express-state', state: expressState }, '*');
        if (expressState.blocked) throw new Error(builderString('expressBlocked', 'Express Production is unavailable while a product marked as ineligible for Express is in your order. Remove it or choose standard production.'));
        if (!expressState.active) {
          if (!expressState.eligible || !expressState.available || !expressState.variantId) throw new Error(builderString('expressUnavailable', 'Express Production is currently unavailable. Choose standard production or try again later.'));
          payload.cart.items = payload.cart.items || [{ id: payload.cart.id, quantity: payload.cart.quantity || 1, properties: payload.cart.properties || {} }];
          payload.cart.items.push({ id: expressState.variantId, quantity: 1 });
        }
      }
      var cartAddUrl = (window.routes.cart_add_url || '/cart/add').replace(/\.js$/, '') + '.js';
      var requestOptions;
      if (payload.cart.items && payload.cart.items.length) {
        var jsonBody = { items: payload.cart.items };
        if (sections.length) {
          jsonBody.sections = sections;
          jsonBody.sections_url = window.location.pathname;
        }
        requestOptions = {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(jsonBody)
        };
      } else {
        var formData = new FormData();
        formData.append('id', String(payload.cart.id));
        formData.append('quantity', String(payload.cart.quantity || 1));
        Object.keys(payload.cart.properties || {}).forEach(function (key) {
          formData.append('properties[' + key + ']', String(payload.cart.properties[key]));
        });
        if (sections.length) {
          formData.append('sections', sections.join(','));
          formData.append('sections_url', window.location.pathname);
        }
        requestOptions = {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
          body: formData
        };
      }
      var response = await fetch(cartAddUrl, requestOptions);
      var responseText = await response.text();
      var data = {};

      try {
        data = JSON.parse(responseText || '{}');
      } catch (parseError) {
        throw new Error(builderString('cartResponseError', 'Cart add returned non-JSON content.'));
      }

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || builderString('addError', 'Could not add this patch to the cart.'));
      }

      var returnTo = getOrderTrackingReturnTo();
      if (returnTo) {
        window.location.assign(returnTo);
        return;
      }

      if (cart) {
        renderCart(data);
      } else {
        window.location = window.routes.cart_url || '/cart';
        return;
      }

      iframe.contentWindow.postMessage({
        type: 'lg:patch-builder:add-to-cart-result',
        success: true,
        cartData: data
      }, '*');
    } catch (error) {
      var message = error && error.message ? error.message : builderString('addError', 'Could not add this patch to the cart.');
      setError(root, message);
      iframe.contentWindow.postMessage({
        type: 'lg:patch-builder:add-to-cart-result',
        success: false,
        error: message
      }, '*');
    }
  }

  function bootRoot(root) {
    var iframe = root.querySelector('[data-lg-patch-builder-iframe]');
    if (!iframe) return;
    var lastHeight = 0;
    var resizeFrame = 0;
    var expressRequest = 0;

    // Liquid starts navigation before this script runs; don't restart that load.
    if (!iframe.src) iframe.src = buildIframeUrl(root);

    window.addEventListener('message', function (event) {
      if (!event.data || event.source !== iframe.contentWindow) return;

      if (event.data.type === 'lg:patch-builder:ready' || event.data.type === 'lg:patch-builder:resize') {
        if (event.data.height) {
          var nextHeight = Math.max(320, Math.ceil(Number(event.data.height || 0)));
          if (Math.abs(nextHeight - lastHeight) < 2) return;
          window.cancelAnimationFrame(resizeFrame);
          resizeFrame = window.requestAnimationFrame(function () {
            lastHeight = nextHeight;
            iframe.style.height = nextHeight + 'px';
            iframe.style.minHeight = '0';
            iframe.setAttribute('data-resized', 'true');
          });
        }
        return;
      }

      if (event.data.type === 'lg:patch-builder:add-to-cart') {
        addToCart(root, iframe, event.data.payload);
      }
      if (event.data.type === 'lg:patch-builder:express-state-request') {
        var requestId = ++expressRequest;
        getExpressState(root, event.data.handles).then(function (state) {
          if (requestId !== expressRequest) return;
          iframe.contentWindow.postMessage({ type: 'lg:patch-builder:express-state', state: state }, '*');
        }).catch(function () {
          if (requestId !== expressRequest) return;
          iframe.contentWindow.postMessage({ type: 'lg:patch-builder:express-state', state: null }, '*');
        });
      }
    });
    iframe.contentWindow.postMessage({ type: 'lg:patch-builder:host-ready' }, '*');
  }

  function boot() {
    var roots = document.querySelectorAll('[data-lg-patch-builder-root]');
    if (!roots.length) return;
    Array.prototype.forEach.call(roots, bootRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
